export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="' + get_svg_url(icon) + '"></use></svg>';
}

function get_svg_url(icon) {
    let svgIconVersion = window.CONFIG.svgIconsVersion;
    if(typeof svgIconVersion === 'undefined') {
        return window.CONFIG.themeUri + '/includes/svg-icons.svg#' + icon;
    }

    if(svgIconVersion === 2) {
        let url = window.CONFIG.themeUri + '/images/svg-icons/' + icon + '.svg';

        if ('undefined' !== typeof window.CONFIG.svgHashes[icon]) {
            url += '?hash=' + window.CONFIG.svgHashes[icon];
        }

        url += '#content';
        return url;
    }

    if(svgIconVersion === 3) {
        let url = window.CONFIG.themeUri + '/images/svg-icons/' + icon + '.svg';
        if ('undefined' !== typeof window.CONFIG.svgData[icon]) {
            url += '?hash=' + window.CONFIG.svgData[icon][2];
        }
        url += '#content';
        return url;
    }

    return window.CONFIG.themeUri + '/includes/svg-icons.svg#' + icon;
}

export function load_json_from_element($element) {
    if ($element.length === 0) return null;

    let json = $element.text();

    return JSON.parse(json);
}

export function pluralise_word(count, suffix, plural_suffix = "s", append_suffix = true) {
    return count + (count !== 1 ? (append_suffix ? suffix : "") + plural_suffix : suffix);
}